export default "/images/talltcolor2.png?1fc8e42479ddf8a18153d81ae7067907";